<template>
  <div class="container container-shadow demo-login-container">

      <h2 class="title">Please enter your registered phone number</h2>

      <el-form :model="formVal" :rules="formRules" label-position="right" ref="formVal" class="register-box register-box-width ">

        <el-form-item class="form-row" prop="phone_country_code">
            <el-select v-model="formVal.phone_country_code" filterable placeholder="Country Code" >
              <el-option
                v-for="(item,index) in country_list"
                :value="item.code"
                :label="item.label" 
                :key="index"
                > 
              </el-option>
            </el-select>
        </el-form-item>

        <el-form-item prop="phone" class="form-row" ref="phone">
            <el-input type="text" v-model="formVal.phone" placeholder="Mobile Number" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item prop="verify_code" class="form-row captcha-row">
            <el-input type="text" v-model="formVal.verify_code" placeholder="Verification Code" auto-complete="off"></el-input>
            <img src='' ref="captcha" @click="_captcha()">
        </el-form-item>

        <el-form-item prop="passcode" class="form-row passcode-row">
            <el-input type="text" v-model="formVal.passcode" placeholder="Mobile Verification Code" auto-complete="off"></el-input>
            <send-code
            v-model="sendCode"
            @click.native="sendPhoneCode"
            storage-key="updatePwd"
            :class="{'btn-loading': sendLoading}"
          ></send-code>
        </el-form-item>

        <div class="form-row form-button">
          <el-button :loading="btnLoading" @click="submitForm('formVal')">Login</el-button>
        </div> 

        <div class="register-tips">
          <router-link  :to="{name:'login'}">Login using password</router-link>
        </div>
      </el-form>
  </div>
</template>

<script>
import { validatePhoneIsExist2, validatePhone } from 'utils/validate'
import sendCode from 'components/sendCode/sendCode'
import { register, sendPasscode, captcha, searchIpArea } from 'service/register'
import * as server from './action'
import _country_list from 'utils/country'
export default {
  beforeRouteEnter(to, from, next) {
    window.vuex_store.commit('set_title', 'Create  Account')
    searchIpArea()
      .then(data => {
        next(vm => vm._setCountryCode(data))
      })
      .catch(() => {
        next()
      })
  },
  data() {
    return {
      btnLoading: false,
      sendCode: false,
      sendLoading: false,
      passType: 'password',
      formVal: {
        phone_country_code: '',
        phone: '',
        passcode: '',
        verify_code: ''
      },
      country_list: _country_list,
      formRules: {
        phone_country_code: [
          { required: true, message: 'Required.', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'Required.', trigger: 'blur' },
          {
            validator: validatePhone,
            trigger: 'blur'
          },
          { validator: validatePhoneIsExist2, trigger: 'blur' }
        ],
        passcode: [
          {
            required: true,
            message: 'Please enter the code received.',
            trigger: 'blur'
          }
        ],
        verify_code: [
          {
            required: true,
            message: 'Please enter your Verification Code.',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {
    sendCode
  },
  created() {
    this._captcha()
  },
  methods: {
    _captcha() {
      captcha().then(res => {
        this.$refs.captcha.setAttribute('src', res.url)
      })
    },
    _setCountryCode(data) {
      this.formVal.phone_country_code = data.code ? Number(data.data.code) : ''
    },
    sendPhoneCode() {
      this.$refs.formVal.validateField('phone_country_code', valid => {
        if (valid) {
          return
        }
        this.$refs.formVal.validateField('phone', valid => {
          if (valid) {
            return
          }
          this.$refs.formVal.validateField('verify_code', valid => {
            if (valid) {
              return
            }
            sendPasscode({
              phone: this.formVal.phone,
              tele_code_type: this.formVal.phone_country_code,
              verify_code: this.formVal.verify_code,
              source: 'login'
            }).then(() => {
              this.sendCode = true
            })
          })
        })
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.btnLoading = true
          server
            .phone_login(this.formVal)
            .then(res => {
              console.log('rse', res)
              localStorage.uk_token = res.token
              this.btnLoading = false
              this.$router.push({ name: 'memberIndex' })
            })
            .catch(() => {
              this.btnLoading = false
            })
        } else {
          console.log('error submit!')
          this.btnLoading = false
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~assets/css/helper/variables.scss';
@import '~assets/css/helper/mixin';
.box-form-row {
  margin-top: 20px;
  .el-form-item__error {
    position: absolute !important;
    right: -250px;
    top: 1px;
    left: auto;
    width: 240px;
    height: 50px;
    border: solid 1px #0A95FF;
    color: #333333;
    font-size: 12px;
    padding: 12px;
    &:before {
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      top: 19px;
      left: -9px;
      border-width: 6px 8px 6px 0;
      border-style: solid solid solid solid;
      border-color: transparent #0A95FF transparent transparent;
    }
    &:after {
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      top: 19px;
      left: -8px;
      border-width: 6px 8px 6px 0;
      border-style: solid solid solid solid;
      border-color: transparent #fff transparent transparent;
    }
  }
}
.demo-login-container {
  // height: 482px;
  padding-bottom: 65px;
  .title {
    text-align: center;
    color: #333;
    font-size: 30px;
    margin-bottom: 30px;
  }
  .register-box {
    width: 705px;
    min-height: 200px;
    margin: 0 auto;

    .form-row {
      margin-bottom: 20px;
      margin-top: 0;
      .el-form-item__label {
        line-height: 52px;
        padding-right: 20px;
      }
      .el-select {
        display: block;
      }
      .el-form-item__error {
        position: static;
      }
    }

    .form-button {
      padding-left: 0;
    }
    .passcode-row {
      position: relative;
      input {
        width: 380px;
      }
      button {
        position: absolute;
        right: 0;
        width: 140px;
        height: 52px;
        background-color: #f2f2f2;
        border: none;
        color: #333333;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
    }
    .captcha-row {
      position: relative;
      input {
        width: 380px;
      }
      img {
        position: absolute;
        top: 0;
        right: 0;
        width: 140px;
        height: 52px;
        background-color: #f2f2f2;
        color: #333333;
        cursor: pointer;
        border: 1px solid #ccc;
        &:hover {
          opacity: 0.8;
        }
      }
    }

    .register-tips {
      padding-left: 0;
      color: #0A95FF;
    }
  }
}
.demo-login-container .register-box-width {
  width: 530px;
  margin: 0 auto;
}
</style>
